﻿import { defineComponent } from 'vue';

import add_on from "./add_on.vue"

import { Booking } from "../../services/booking";

import { booking_group } from "../../objects/v1_2/Booking/Booking_Group"
import { booking_search_group } from "../../objects/v1_2/Booking_Details/booking_search_group"

const Book = new Booking();

export default defineComponent({
    components: {
        add_on
    },
    methods: {
        async Get_Quote() {
            await Book.Get_Session_Information(this.getSession_ID()).then(async (User_Info) => {
                this.$store.commit("Set_Booking_Login", { Booking_Login: User_Info });
                this.$store.commit("Setup_Booking", { Booking_Details: await Book.Download_Booking(User_Info.booking_info.booking_identifier) });
            });
        },
        get_Booking(): booking_search_group {
            return this.$store.getters.get_Booking;
        },
        getSession_ID(): string {
            let url = window.location.href;
            let params = url.split("/");
            let displayText = "";

            if (params.length > 0) {
                displayText = params[params.length - 1];
            }

            return displayText;
        },
        total_add_ons(): string {
            let Add_Ons: number = Book.getTotal_Add_Ons(this.$store.getters.get_Basket);

            if (Add_Ons == 0) {
                return "no add-ons";
            }

            if (Add_Ons == 1) {
                return "1 add-on";
            }

            return Add_Ons + " add-ons";
        },
    },
    async mounted() {
        await this.Get_Quote();
    }
})